import React from 'react';
import { Sidebar } from './Sidebar';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex h-screen bg-slate-50 overflow-hidden font-sans" data-id="element-43" data-mp="kz3okndknmt1">
      <Sidebar data-id="element-44" data-mp="zxxoiam0ya1m" />

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-45" data-mp="zwcsegk2aj1n">
        <main className="flex-1 overflow-y-auto p-8" data-id="element-46" data-mp="uyb9pwqjslqp">{children}</main>
      </div>
    </div>;
}